export default "__VITE_ASSET__CmwbLIC8__"